import React, { useEffect, useState } from 'react';

/**
 * Botão inline para alternar entre tema claro e escuro.
 * - Renderiza com a classe passada via prop `className` (default usa estilo do header do Dashboard).
 * - Preferência persistida em localStorage (`comex_theme`).
 * - Define `html[data-theme="dark"|"light"]` que ativa/desativa o darkmode.css.
 */

const STORAGE_KEY = 'comex_theme';
const DEFAULT_THEME = 'dark';

/**
 * Props:
 *  - className: classe CSS do botão (default usa estilo do header do Dashboard)
 *  - as: 'icon' (default) ou 'menu-item' — em 'menu-item' renderiza ícone + rótulo
 */
const ThemeToggle = ({ className = 'dash-icon-btn', as = 'icon' }) => {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === 'light' || saved === 'dark' ? saved : DEFAULT_THEME;
    } catch (_) {
      return DEFAULT_THEME;
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (_) {}
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  const isDark = theme === 'dark';
  const ariaLabel = isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro';
  const iconClass = isDark ? 'fas fa-sun' : 'fas fa-moon';

  if (as === 'menu-item') {
    return (
      <button
        type="button"
        onClick={toggle}
        aria-label={ariaLabel}
        className={className}
      >
        <i className={iconClass}></i> {isDark ? 'Modo claro' : 'Modo escuro'}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={ariaLabel}
      title={ariaLabel}
      className={className}
    >
      <i className={iconClass}></i>
    </button>
  );
};

export default ThemeToggle;
